import DOMPurify from 'dompurify';
import { Marked } from 'marked';

const markdown = new Marked({ breaks: true, gfm: true, async: false });

// Assistant output and saved conversations are untrusted. Keep Markdown's
// text formatting, but do not let messages load resources or alter page UI.
const policy = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'del', 's', 'blockquote', 'pre', 'code',
    'ul', 'ol', 'li', 'hr', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'table', 'thead', 'tbody', 'tr', 'th', 'td', 'a',
  ],
  ALLOWED_ATTR: ['href', 'title', 'start'],
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
  ALLOWED_URI_REGEXP: /^(?:https?:\/\/|mailto:|tel:)/i,
};

export function renderSafeMarkdown(text) {
  const html = markdown.parse(typeof text === 'string' ? text : '');
  // Sanitization is the final transformation before insertion into the DOM.
  return DOMPurify.sanitize(html, policy);
}
